export const all_articles = [
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/17/is-a-columbia-four-peat-possible-what-to-expect-this-ivy-league-womens-basketball-season/",
        article_title: "Is a Columbia four-peat possible? What to expect this Ivy League women’s basketball season",
        article_authors: "Jillian Prunty & Nicholas Fink",
        image_url: "https://www.columbiaspectator.com/resizer/v2/4OCFHKJVSRCXPJPMGHMUHPHX6E.JPG?auth=3ce58bae10c5adfb972bcc67b3f66cec515589764c4329dc4b1aa9b30c00201f"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/17/will-the-lions-learn-from-last-years-collapse-what-to-expect-this-ivy-league-mens-basketball-season/",
        article_title: "Will the Lions learn from last year’s collapse? What to expect this Ivy League men’s basketball season",
        article_authors: "Andrew Vincenti",
        image_url: "https://www.columbiaspectator.com/resizer/v2/DRFQPKJYZFCH7NWY3C5XGQ4PLQ.jpg?auth=cc2d6ae454e1f4ac9b7bedd903eb86520f324aba9074b93b0a8c65257a125c19"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/20/cubs-on-the-prowl-a-look-at-womens-basketballs-newcomers/",
        article_title: "Cubs on the prowl: A look at women’s basketball’s newcomers",
        article_authors: "Arielle Rieder",
        image_url: "https://www.columbiaspectator.com/resizer/v2/NAPFMGXMHVABFP62CKOB2MPFOY.png?auth=b5ffd64a972878c53a4a7b45aadf7718c93e08368af05642a650f42a80c03a80"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/20/mens-basketball-welcomes-six-new-lions-to-the-2025-26-lineup/",
        article_title: "Men’s basketball welcomes six new Lions to the 2025-26 lineup",
        article_authors: "Annie Han",
        image_url: "https://www.columbiaspectator.com/resizer/v2/CLM673L7KFAHFPTUC3DZMUW7VA.png?auth=2f7cccb7301488c2e986921640f4b80f8fddac9bd37e118c9feea4d25af34cb0"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/12/in-a-historic-gift-columbia-basketball-receives-10-million-from-jonathan-and-jeannie-lavine/",
        article_title: "In historic gift, Columbia basketball receives $10 million from Jonathan and Jeannie Lavine",
        article_authors: "Kaya Quebada",
        image_url: "https://www.columbiaspectator.com/resizer/v2/VYHELRJAENEUXIYEMNRTMXVEHY.jpg?auth=85631c93d3dfd8bb38d9477a3337bd4a954ec05b22f757e4c9bc14b13399455e"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/19/from-the-barnard-bears-to-the-big-dance-tracing-the-evolution-of-womens-basketball-at-columbia/",
        article_title: "From the Barnard Bears to the Big Dance: Tracing the evolution of women’s basketball at Columbia",
        article_authors: "Jillian Prunty",
        image_url: "https://www.columbiaspectator.com/resizer/v2/XZYHSWT5SJEDLLGCI3Y2DULROI.png?auth=a54a047739545137b0f3c508cea5fcb7becbca0c972695b5e8327c6d2186f143"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/19/we-show-up-for-our-players-womens-basketballs-new-assistant-coach-kizmahr-grell-on-team-sisterhood-and-consistency/",
        article_title: "‘We show up for our players’: Women’s basketball’s new assistant coach Kizmahr Grell on team sisterhood and consistency",
        article_authors: "Robby Swan",
        image_url: "https://www.columbiaspectator.com/resizer/v2/B7HJTHQNVBDOBGZRK6HEGEE44A.jpg?auth=e6c922ae1dade2c57b6a042d921ad0b1245a134b497fb857232ca044273218f7"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/19/from-first-year-tragedies-to-career-highs-junior-forward-richard-nweke-reflects-on-his-path-back-to-the-court/",
        article_title: "From first-year tragedies to career highs: Junior forward Richard Nweke reflects on his path back to the court",
        article_authors: "Emily Michaelsen",
        image_url: "https://www.columbiaspectator.com/resizer/v2/DWEX3EPDAJCVDMZUJ2HXOMYIBM.jpg?auth=57cbd333bd4985b1ee8998faffd606d48e748663ba32b6281b69fa35034c59d6"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/20/introducing-the-new-mens-basketball-coaching-staff/",
        article_title: "Introducing the new men’s basketball coaching staff",
        article_authors: "Holden Lombardo",
        image_url: "https://www.columbiaspectator.com/resizer/v2/CBTDIWMPENF6JAH45IUBY2DTM4.jpg?auth=fae51a94af3f188bb2e07bbe520aa71b7b9cce4646ad59bb675fc8a8e4ac232d"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/20/how-kevin-hovde-is-making-mens-basketball-his-own/",
        article_title: "How Kevin Hovde is making men’s basketball his own",
        article_authors: "Kaya Quebada & Andrew Vincenti",
        image_url: "https://www.columbiaspectator.com/resizer/v2/XGNF3KE5EBEJJBGPFQQP332J3M.jpg?auth=92d20e89acd1855c5db63d7fb8662459a28b3b0c916c71cf0c36c710cf20d09d"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/03/ominous-opening-cornell-upsets-womens-basketball-67-60/",
        article_title: "Ominous opening: Cornell upsets women’s basketball 67-60",
        article_authors: "Nicholas Fink",
        image_url: "https://www.columbiaspectator.com/resizer/v2/YPZN3M2WZZBZLCGCUHLZQ6WJQY.jpg?auth=ff9535c61e950aecc9f62b073d6656bfd3d0d6386edc3b06abd55aa626fe4439"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/10/mens-basketball-rebounds-with-three-straight-wins-after-midseason-slip/",
        article_title: "Men’s basketball rebounds with three straight wins after midseason slip",
        article_authors: "Andrew Vincenti",
        image_url: "https://www.columbiaspectator.com/resizer/v2/RNMXXQ33KBCCFB7DTVRU42TGNU.jpg?auth=28ac94947bfa2cfdc361899b13244e3b827d9db6d6effd4c01eabf67a80a0f13"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/10/womens-basketball-narrowly-defeats-harvard-for-first-ivy-win/",
        article_title: "Women’s basketball narrowly defeats Harvard for first Ivy win",
        article_authors: "Jillian Prunty",
        image_url: "https://www.columbiaspectator.com/resizer/v2/IUMS7NJUNNDWBP4FJHFLGDUL2Q.jpg?auth=ad59c8fd2a0dc0a58bf66ea5c1874808a44b0f953101f8f94ea5608874908e9f"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/17/highway-robbery-nasi-simmons-shuts-down-yale-in-womens-basketball-win/",
        article_title: "Highway robbery: Nasi Simmons shuts down Yale in women’s basketball win",
        article_authors: "Nicholas Fink",
        image_url: "https://www.columbiaspectator.com/resizer/v2/Z3VXIVTKTFFFRE27KHLLN32FWM.jpg?auth=776bcf49b19e59015531b52a017e2a6c0d40405995e3e6dda499c774f84468b7"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/19/womens-basketball-beats-brown-improves-to-3-1-in-conference-play/",
        article_title: "Women’s basketball beats Brown, improves to 3-1 in conference play",
        article_authors: "Jillian Prunty",
        image_url: "https://www.columbiaspectator.com/resizer/v2/BNI5CUVD4NCBXKWHOUD4XTCMRE.jpg?auth=ed55e1ff50640e9bc4a610c4b3c5301787d11aa361c0a32d1804ee0c198e354c"
    }
];
